import moment from "moment";

const format = "HH:mm:ss";

export const formatTime = (time) => moment(time).format(format);

export function calculateAddHHmmArrayToMoment(momentTime, array) {
  const clone = momentTime.clone();
  array.map((element) => clone.add(moment.duration(element)));
  return clone;
}

export function getPassedMinutesOnlyTime(moment1, moment2) {
  const time1 = moment1.format(format);
  const time2 = moment2.format(format);
  const date1 = moment(time1, format);
  const date2 = moment(time2, format);

  const duration = moment.duration(date2.diff(date1));
  const minutes = duration.asMinutes();
  return minutes;
  // return moment(time1, format).diff(moment(time2, format));
}

export function getPassedMinutesOnlyTimeSeconds(moment1, moment2) {
  const time1 = moment1.format(format);
  const time2 = moment2.format(format);
  const date1 = moment(time1, format);
  const date2 = moment(time2, format);

  const duration = moment.duration(date2.diff(date1));
  const seconds = duration.asSeconds();
  return seconds;
  // return moment(time1, format).diff(moment(time2, format));
}

export function getDuration(moment1, moment2) {
  const duration = moment.duration(moment2.diff(moment1));
  const minutes = duration.asSeconds();
  return minutes;
  // return moment(time1, format).diff(moment(time2, format));
}

export function isAgendaItemActive(array, starttime, actualtime) {
  let starttimeAgendaItem = starttime.clone();
  let endtimeAgendaItem = moment(starttime.toISOString());

  for (let i = 0; i < array.length; i++) {
    endtimeAgendaItem = calculateAddHHmmArrayToMoment(endtimeAgendaItem, [
      array[i].time,
    ]);
    if (i !== 0) {
      starttimeAgendaItem.add(moment.duration(array[i - 1].time));
    }
  }
  return actualtime.isBetween(starttimeAgendaItem, endtimeAgendaItem);
}

export function getEndtime(array, starttime) {
  let endtimeAgendaItem = moment(starttime.toISOString());

  for (let i = 0; i < array.length; i++) {
    endtimeAgendaItem = calculateAddHHmmArrayToMoment(endtimeAgendaItem, [
      array[i].time,
    ]);
  }
  return endtimeAgendaItem;
}

export function getStarttime(array, starttime) {
  let starttimeAgendaItem = starttime.clone();

  for (let i = 0; i < array.length; i++) {
    if (i !== 0) {
      starttimeAgendaItem.add(moment.duration(array[i - 1].time));
    }
  }
  return starttimeAgendaItem;
}

// Status of every agenda item relative to actualtime: "done" (already ran),
// "active" (running right now), "next" (the first item still to come) or
// "upcoming" (further out). There is at most one "active" and one "next".
export function computeAgendaStatuses(agenda, starttime, actualtime) {
  const statuses = agenda.map((_, index) => {
    const array = agenda.slice(0, index + 1);
    const taskEnd = getEndtime(array, starttime);
    if (actualtime.isSameOrAfter(taskEnd)) {
      return "done";
    }
    if (isAgendaItemActive(array, starttime, actualtime)) {
      return "active";
    }
    return "upcoming";
  });

  const nextIndex = statuses.indexOf("upcoming");
  if (nextIndex !== -1) {
    statuses[nextIndex] = "next";
  }
  return statuses;
}

// "4:05" or "1:02:30": what is left of the running card.
export function formatCountdown(totalSeconds) {
  const seconds = Math.max(0, Math.ceil(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = String(seconds % 60).padStart(2, "0");
  return hours
    ? `${hours}:${String(minutes).padStart(2, "0")}:${rest}`
    : `${minutes}:${rest}`;
}
